/**
 * 多维分析和号码包提取页面的 添加数据源模态框的文本配置
 */
export default {
  dbl_dataSource_step_one_title: "Select Data Table",
  dbl_dataSource_step_two_title: "Set Association Relationship",
  dbl_dataSource_step_there_title: "Select Chart Type",
  dbl_dataSource_first_level: "Level One Category",
  dbl_dataSource_second_level: "Level Two Category",
  dbl_dataSource_search_placeholder: "Search by name, description, field or administrator",
  dbl_dataSource_table_name: "Name",
  dbl_dataSource_table_description: "Description",
  dbl_dataSource_table_cycle: "Table Cycle",
  dbl_dataSource_usage_count: "Usage Count",
  dbl_dataSource_table_database: "Database Type",
  dbl_dataSource_database_name: "Database Name",
  dbl_dataSource_self_join: "Self-join",
  dbl_dataSource_self_join_des: "Description",
  dbl_dataSource_self_join_demo: "Demo",
  dbl_dataSource_joining_field: "Joining Field",
  dbl_dataSource_add: "Add",
  dbl_dataSource_delete: "Delete",
  dbl_dataSource_next_step: "Next Step",
  dbl_dataSource_prev_step: "Prev Step",
  dbl_dataSource_preview_data: "Preview Data",
  dbl_dataSource_submit: "Submit",
  dbl_dataSource_auto_create: "Auto-Create Report",
  dbl_dataSource_create_table: "Create A Blank Report",
	
  // 添加数据源后, 页面显示相关文本
  dbl_dataSource_public: "Public",
  dbl_dataSource_dimension: "Dimension",
  dbl_dataSource_metric: "Metric",
	
  dbl_dataSource_more_then_three: "Select up to 3, please cancel and then select",
  dbl_dataSource_not_same: "Cannot join a table if it is not the same data source",
	
  dbl_dataSource_left_join: "left join",
  dbl_dataSource_right_join: "right join",
  dbl_dataSource_inner_join: "inner join",
  dbl_dataSource_full_join: "full join",
	
  dbl_dataSource_relation_select: "Associated Field Selection",
  dbl_dataSource_relation_search: "Search fields",
  dbl_dataSource_relation_not_match: "Association field type does not match",
  dbl_dataSource_relation_select_info: "Please select the associated field",
	
  dbl_dataSource_tooltip: "The system table information does not match the database table information. Please contact the data classmate and v_blljli to check.",
  dbl_dataSource_sql_step_one_title: "Edit SQL",
  dbl_dataSource_sql_step_two_title: "Save SQL",

  dbl_dataSource_self_join_success: "Successful self join",
  dbl_dataSource_add_table: "The data source has been added successfully.",
  dbl_dataSource_join_table: "Successfully associated {count} data tables",
  
  dbl_dataSource_confirm_replace_title: "Confirm Data Source Replacement?",
  dbl_dataSource_confirm_replace_info: "You've changed the data source. All matching fields (filters, dimensions, metrics) have been retained.<br/>" +
    "Note: Unmatched fields will be removed from your operation area, including the Filters, Dimensions, and Metrics.",
};